<template>
  <router-view />
</template>
<script>
export default {
  name: 'LogsViewer'
}
</script>

<style scoped></style>
